var Ractive = require('ractive');
var component = module;
component.exports.template = {v:4,t:[{p:[1,1,0],t:7,e:"div",m:[{n:"class",f:"page-content",t:13}],f:[{p:[2,3,30],t:7,e:"h2",f:["PRAZNO"]}," ",{p:[3,3,49],t:7,e:"br"}]}]};
module.exports = Ractive.extend(component.exports);



//////////////////
// WEBPACK FOOTER
// ./~/ractive-component-loader!./ractive/Project/ERP/Page/Empty.html
// module id = 31
// module chunks = 0